import { memo, useContext } from "react";
import { Link } from "react-router-dom";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./inner.css";
import { data1 } from "../App";

function LinkMenuBox() {
  const setServiceseta = useContext(data1);
  return (
    <>
      <ul className="headmenu">
        <li>
          <Link to="/" className="headlink">
            Home
          </Link>
        </li>
        <li>
          <Link to="/about" className="headlink">
            About
          </Link>
        </li>
        <li>
          <Link className="headlink">Our Doctor</Link>
          <ul className="submenu">
            <li>
              <Link to="/drchethankumarr" className="headlink subheadlink">
                Dr Chethan Kumar R
              </Link>
            </li>
            {/* <li>
              <Link to="/drkrupankabv" className="headlink subheadlink">
                Dr Krupanka BV
              </Link>
            </li> */}
          </ul>
        </li>
        <li>
          <Link className="headlink">Services</Link>
          <ul className="submenu">
            <li>
              <Link className="headlink subheadlink">Orthopedic Services</Link>
              <div className="obgmenu">
                {/* COLUMN 1 */}
                <ul className="ulobgmenu">
                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() => setServiceseta("Orthopaedic Clinic")}
                      to="/service/orthopaedicClinic"
                      className="headlink orsubmenu"
                    >
                      Orthopaedic Clinic
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() => setServiceseta("Orthopaedic Consultation")}
                      to="/service/orthopaedicConsultation"
                      className="headlink orsubmenu"
                    >
                      Orthopaedic Consultation
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta(
                          "Evaluation and Diagnosis of Bone, Joint, Muscle and Ligament Problems",
                        )
                      }
                      to="/service/orthopaedicEvaluation"
                      className="headlink orsubmenu"
                    >
                      Evaluation & Diagnosis
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta("Personalized Treatment Planning")
                      }
                      to="/service/treatmentPlanning"
                      className="headlink orsubmenu"
                    >
                      Personalized Treatment Planning
                    </Link>
                  </li>

                  {/* OLD (keep old full title) */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta(
                          "Bone Fracture Treatment Surgical And Conservative Treatment",
                        )
                      }
                      to="/service/boneFracture"
                      className="headlink orsubmenu"
                    >
                      Bone Fracture Treatment Surgical And Conservative
                      Treatment
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() => setServiceseta("Fracture & Trauma Care")}
                      to="/service/fractureTraumaCare"
                      className="headlink orsubmenu"
                    >
                      Fracture & Trauma Care
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta(
                          "Plaster Casting, Splinting and Follow-up Care",
                        )
                      }
                      to="/service/plasterCasting"
                      className="headlink orsubmenu"
                    >
                      Plaster Casting, Splinting & Follow-up Care
                    </Link>
                  </li>
                </ul>

                {/* COLUMN 2 */}
                <ul className="ulobgmenu">
                  {/* OLD (missing earlier in your new menu) */}
                  <li>
                    <Link
                      onClick={() => setServiceseta("Sport Medicine")}
                      to="/service/sportMedicine"
                      className="headlink orsubmenu"
                    >
                      Sport Medicine
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() => setServiceseta("Sports Injury Management")}
                      to="/service/sportsInjury"
                      className="headlink orsubmenu"
                    >
                      Sports Injury Management
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta("Ligament Injuries (ACL, PCL, Meniscus)")
                      }
                      to="/service/ligamentInjuries"
                      className="headlink orsubmenu"
                    >
                      Ligament Injuries (ACL/PCL/Meniscus)
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta("Tendon Injuries and Muscle Strains")
                      }
                      to="/service/tendonMuscleInjuries"
                      className="headlink orsubmenu"
                    >
                      Tendon Injuries & Muscle Strains
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta("Return-to-Sport Rehabilitation")
                      }
                      to="/service/returnToSport"
                      className="headlink orsubmenu"
                    >
                      Return-to-Sport Rehabilitation
                    </Link>
                  </li>

                  {/* OLD (keep once, consistent naming) */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta(
                          "Arthroscopic Acl Andmenicus Repair Reconstruction",
                        )
                      }
                      to="/service/arthroscopicAcl"
                      className="headlink orsubmenu"
                    >
                      Arthroscopic Acl Andmenicus Repair Reconstruction
                    </Link>
                  </li>

                  {/* OLD */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta("Arthroscopic Shoulder Surgeries")
                      }
                      to="/service/arthroscopicShoulder"
                      className="headlink orsubmenu"
                    >
                      Arthroscopic Shoulder Surgeries
                    </Link>
                  </li>
                </ul>

                {/* COLUMN 3 */}
                <ul className="ulobgmenu">
                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta("Arthroscopy (Keyhole Surgery)")
                      }
                      to="/service/arthroscopy"
                      className="headlink orsubmenu"
                    >
                      Arthroscopy (Keyhole Surgery)
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta("Arthritis & Joint Pain Management")
                      }
                      to="/service/arthritisJointPain"
                      className="headlink orsubmenu"
                    >
                      Arthritis & Joint Pain Management
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta("Joint Replacement Services")
                      }
                      to="/service/jointReplacement"
                      className="headlink orsubmenu"
                    >
                      Joint Replacement Services
                    </Link>
                  </li>

                  {/* OLD (keep old full title) */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta(
                          "Knee And Hip Replacement Surgery Primary And Revision",
                        )
                      }
                      to="/service/kneeAndHip"
                      className="headlink orsubmenu"
                    >
                      Knee And Hip Replacement Surgery Primary And Revision
                    </Link>
                  </li>

                  {/* OLD */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta(
                          "Back Pain And Disc Related Diseases Treatment",
                        )
                      }
                      to="/service/backPain"
                      className="headlink orsubmenu"
                    >
                      Back Pain And Disc Related Diseases Treatment
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() => setServiceseta("Back & Spine Care")}
                      to="/service/backSpineCare"
                      className="headlink orsubmenu"
                    >
                      Back & Spine Care
                    </Link>
                  </li>
                </ul>

                {/* COLUMN 4 */}
                <ul className="ulobgmenu">
                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() => setServiceseta("Paediatric Orthopaedics")}
                      to="/service/paediatricOrthopaedics"
                      className="headlink orsubmenu"
                    >
                      Paediatric Orthopaedics
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta(
                          "Congenital Deformities & Growth Related Issues",
                        )
                      }
                      to="/service/congenitalOrtho"
                      className="headlink orsubmenu"
                    >
                      Congenital Deformities & Growth Issues
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta("Pain Management Procedures")
                      }
                      to="/service/painManagement"
                      className="headlink orsubmenu"
                    >
                      Pain Management Procedures
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() => setServiceseta("Joint Injections")}
                      to="/service/jointInjections"
                      className="headlink orsubmenu"
                    >
                      Joint Injections
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta(
                          "PRP and Non-Surgical Pain Relief Options",
                        )
                      }
                      to="/service/prpTherapy"
                      className="headlink orsubmenu"
                    >
                      PRP & Non-Surgical Pain Relief Options
                    </Link>
                  </li>

                  {/* NEW */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta(
                          "Rehabilitation & Physiotherapy Guidance",
                        )
                      }
                      to="/service/rehabilitation"
                      className="headlink orsubmenu"
                    >
                      Rehabilitation & Physiotherapy Guidance
                    </Link>
                  </li>

                  {/* OLD (keep old full title) */}
                  <li>
                    <Link
                      onClick={() =>
                        setServiceseta("Diabetic Wound Dressing And Management")
                      }
                      to="/service/diabeticWound"
                      className="headlink orsubmenu"
                    >
                      Diabetic Wound Dressing And Management
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            <li></li>
            {/* <li>
              <Link className="headlink subheadlink">OBG Services</Link>
              <div className="obgmenu">
                <ul className="ulobgmenu">
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("General Obstetrics");
                      }}
                      to="/service/generalObstetrics"
                      className="headlink obgsubmenu"
                    >
                      General Obstetrics
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("High Risk Obstetric Cases");
                      }}
                      to="/service/highRiskObstetric"
                      className="headlink obgsubmenu"
                    >
                      High Risk Obstetric Cases
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("PIH(Pregnancy Induced Hypertension)");
                      }}
                      to="/service/pih"
                      className="headlink obgsubmenu"
                    >
                      PIH(Pregnancy Induced Hypertension)
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("APH(Antepartum Haemorrhage)");
                      }}
                      to="/service/aph"
                      className="headlink obgsubmenu"
                    >
                      APH(Antepartum Haemorrhage)
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("PPH(Postpartum Haemorrhage)");
                      }}
                      to="/service/pph"
                      className="headlink obgsubmenu"
                    >
                      PPH(Postpartum Haemorrhage)
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("Ectopic Pregnancy");
                      }}
                      to="/service/ectopicPregnancy"
                      className="headlink obgsubmenu"
                    >
                      Ectopic Pregnancy
                    </Link>
                  </li>
                </ul>
                <ul className="ulobgmenu">
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("Pre-Eclampsia");
                      }}
                      to="/service/preEclampsia"
                      className="headlink obgsubmenu"
                    >
                      Pre-Eclampsia
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("Inevitable Abortion");
                      }}
                      to="/service/inevitableAbortion"
                      className="headlink obgsubmenu"
                    >
                      Inevitable Abortion
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("Respiratory Problems With Pregnancy");
                      }}
                      to="/service/respiratory"
                      className="headlink obgsubmenu"
                    >
                      Respiratory Problems With Pregnancy
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("Orthopedic Problem With Pregnancy");
                      }}
                      to="/service/orthopedicProblem"
                      className="headlink obgsubmenu"
                    >
                      Orthopedic Problem With Pregnancy
                    </Link>
                  </li>

                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("Infections Disease");
                      }}
                      to="/service/infectionsDisease"
                      className="headlink obgsubmenu"
                    >
                      Infections Disease
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("Hysterectomy");
                      }}
                      to="/service/hysterectomy"
                      className="headlink obgsubmenu"
                    >
                      Hysterectomy
                    </Link>
                  </li>
                </ul>
              </div>
            </li> */}
            <li>
              <Link className="headlink subheadlink">Services in clinic</Link>
              <div className="clinicmenu">
                <ul className="ulobgmenu">
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("High intensity digital xray");
                      }}
                      to="/service/highintensity"
                      className="headlink clinicsubmenu"
                    >
                      High intensity digital xray
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("Laboratory blood collection centre");
                      }}
                      to="/service/laboratory"
                      className="headlink clinicsubmenu"
                    >
                      Laboratory blood collection centre
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setServiceseta("Wound dressing");
                      }}
                      to="/service/wounddressing"
                      className="headlink clinicsubmenu"
                    >
                      Wound dressing
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </li>
        <li>
          <Link to="/gallery" className="headlink">
            Gallery
          </Link>
        </li>
        <li>
          <Link to="/contact" className="headlink">
            Contact
          </Link>
        </li>
      </ul>
    </>
  );
}
export default memo(LinkMenuBox);
